import { rem } from 'polished'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { tileDesktopLayout } from './constants'

// Can't use `<Group />` as our element relies on container queries, not known breakpoints
const Container = styled.div`
  grid-area: secondary-content;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: ${rem(16)};

  ${tileDesktopLayout} {
    padding: ${rem(20)};
    padding-left: 0;
    flex-direction: column;
    gap: ${rem(24)};
    align-items: end;
  }
`

interface Props extends React.PropsWithChildren {
  price?: ReactNode
}

function CartReviewTileSecondaryContent({
  price,
  children,
}: Props) {
  return (
    <Container>
      {children}
      {price}
    </Container>
  )
}

export default CartReviewTileSecondaryContent
